export default {
  name: 'OrganizationsController',
  fn: () => {}
};